<template>
  <div>
    <JoinWrapper v-if="isPc" page-type="cart">
      <div class="box_wrap" data-detail="cart_detail">
        <!-- #region PROGRESS BAR START -->
        <div class="cart_progress">
          <div class="progress_box">
            <p class="cell">
              <span class="fn_mont">{{
                $t('views.cart.deliveryinfo.7183')
              }}</span>
              {{ $t('views.cart.deliveryinfo.4061') }}
            </p>
          </div>
          <div class="c_icon ico_progress_arrow"></div>
          <div class="progress_box active">
            <p class="cell">
              <span class="fn_mont">{{
                $t('views.cart.deliveryinfo.2670')
              }}</span>
              {{ $t('views.cart.deliveryinfo.2037') }}
            </p>
          </div>
          <div class="c_icon ico_progress_arrow"></div>
          <div class="progress_box">
            <p class="cell">
              <span class="fn_mont">{{
                $t('views.cart.deliveryinfo.724')
              }}</span>
              {{ $t('views.cart.deliveryinfo.2648') }}
            </p>
          </div>
        </div>
        <!-- #endregion  PROGRESS BAR END -->

        <div class="box">
          <div class="top_title">
            <p class="cart2_title">{{ $t('views.cart.deliveryinfo.5916') }}</p>
            <div class="btn_wrap tar">
              <button
                type="button"
                class="more_order_book"
                :class="{ active: showAllItems }"
                @click="toggleShowAllItems"
              >
                <span class>
                  {{ showAllItems ? '전체 상품 닫기' : '전체 상품 보기' }}
                </span>
              </button>
            </div>
          </div>

          <ul v-if="getCart" class="order_book" data-detail="cart_2">
            <!-- ORDER ITEMS START -->
            <li v-for="item in formattedItemList" :key="item.cartGoodsSeq">
              <div class="cover_wrap">
                <router-link
                  :to="{
                    name: 'book_detail',
                    params: { id: item.bookCd || '0' }
                  }"
                  class="thum_wrap"
                >
                  <img :src="item.thumbUrl" alt="책제목" />
                </router-link>
              </div>

              <div class="info_wrap">
                <div class="upside">
                  <div class="title_gray"></div>
                  <h3 class="meta_title order_info" :title="item.bookNm || ''">
                    {{ item.bookNm || '' }}
                  </h3>
                  <div class="title_gray"></div>
                  <h3 class="meta_title order_info">
                    상품금액
                    <span
                      v-if="
                        item.listAmt > item.saleAmt ||
                        item.bookCd == 'BO-20250219000100072' || // 정신건강간호학 9판
                        item.bookCd == 'BO-20250206000100001' // 아동간호학 3판
                      "
                      style="font-size: 12px; color: red;"
                    >
                      * 해당 상품은 할인쿠폰 적용이 불가능 합니다</span
                    >
                  </h3>
                </div>
                <div class="downside">
                  <p class="book_data">
                    <span class="meta_author">{{ item.author }}</span>
                    <span class="gap">/</span>
                    <span class="meta_publisher">{{ item.publisher }}</span>
                  </p>
                  <p class="option_title">
                    <span class="option_box">옵션</span>
                    <span class="meta_total_count base_CT16">
                      {{ item.options.optDesc }}
                    </span>
                  </p>
                  <div class="price_wrap">
                    <div class="option_desc">{{ item.options.optDesc }}</div>
                    <ul class="meta_detail">
                      <li>
                        <p class="meta_price">
                          <strong v-if="item.saleAmt">
                            <vue-intl-numberformat
                              locale="ko-KR"
                              class="price"
                              format-style="decimal"
                              :currency="getCurrency.currency"
                              :number="item.saleAmt"
                            />
                            원
                          </strong>

                          <strong v-if="!item.saleAmt">
                            <vue-intl-numberformat
                              locale="ko-KR"
                              class="price"
                              format-style="decimal"
                              :currency="getCurrency.currency"
                              :number="0"
                            />
                          </strong>
                        </p>
                      </li>
                      <!-- REMOVE DELIVERY COST INFO -->
                    </ul>
                  </div>
                  <div class="discount_wrap">
                    <span>
                      <span v-if="item.listAmt > item.saleAmt" class="discount">
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="decimal"
                          :currency="getCurrency.currency"
                          :number="item.listAmt"
                        />
                        원
                      </span>
                      <span v-if="item.listAmt > item.saleAmt" class="percent">
                        ( {{ item.discountPercent }}
                        <span class="arrow">{{
                          $t('views.cart.cart.discount')
                        }}</span>
                        )
                      </span>
                    </span>
                  </div>
                </div>

                <!-- 첫번째 주문상품에만 보이기 // 전체 상품보기 활성화 시 display:none -->
              </div>
            </li>
            <!-- ORDER ITEMS END -->
          </ul>
        </div>
        <!-- DISCOUNT COUPON SECTION START-->
        <!-- 위험 START-->
        <!-- EBOOK SECTION START -->
        <div v-if="!isGift" class="box" data-detail="margin_0">
          <div class="top_title">
            <p>할인 쿠폰</p>
            <div class="btn_wrap tar">
              <button
                type="button"
                class="more_order_book"
                :class="{ active: showAllCoupons }"
                @click="toggleShowAllCoupons"
              >
                <span class>
                  {{ showAllCoupons ? '쿠폰 목록 닫기' : '쿠폰 목록 보기' }}
                </span>
              </button>
            </div>
          </div>
          <!-- EBOOK LIST SECTION START -->
          <ul
            v-if="combinedItemList && showAllCoupons"
            class="order_book"
            data-detail="cart_3"
          >
            <li
              v-for="(item, index) in safeDiscntList"
              :key="`${item.discntSeq}`"
              class="join_check"
            >
              <div class="text_label">
                <label>
                  <input
                    v-model="discountSelected"
                    type="checkbox"
                    name="agree"
                    class=""
                    :title="item.bookName + `선택`"
                    :value="{
                      bookCode: item.bookCode,
                      discountWon: item.discntWon || 0,
                      discountRate: item.discntRate || 0,
                      discountSeq: item.discntSeq,
                      discountTp: item.discntTp
                    }"
                    :disabled="
                      item.bookCode === undefined || item.bookCode === ''
                    "
                    @change="checkDuplicate(item.bookCode)"
                  />
                  <em></em>
                  <span>{{ item.bookName }}선택</span>
                </label>
              </div>

              <div class="info_wrap">
                <div
                  class="cover_wrap"
                  :class="{ hidden: getThumbIndex(item) < 0 }"
                >
                  <router-link
                    :to="{
                      name: 'book_detail',
                      params: { id: item.bookCode || '0' }
                    }"
                    class="thum_wrap"
                  >
                    <img
                      v-if="getThumbIndex(item) >= 0"
                      :src="combinedItemList[getThumbIndex(item)].thumbUrl"
                      alt="책제목"
                    />
                  </router-link>
                </div>
                <h3 class="meta_title">
                  <span v-if="item.bookName">
                    <span class="coupon_book">{{ item.bookName }}</span>
                    <span v-if="item.discntTp === 'WON'" class="coupon_info">
                      {{ item.discntWon }}원 할인쿠폰
                    </span>
                    <span v-if="item.discntTp === 'RATE'" class="coupon_info">
                      {{ item.discntRate }}% 할인쿠폰
                    </span>
                  </span>

                  <span v-if="!item.bookName">
                    <select
                      v-model="selectedEmptyCoupon[index]"
                      @change="changeSelectCoupon(item, index)"
                    >
                      <option value="">
                        이곳을 클릭하여 도서를 선택해 주세요
                      </option>
                      <option
                        v-for="list in filteredCombinedItemList"
                        :key="list.idx"
                        :value="list.bookCd"
                        :disabled="selectedEmptyCoupon.includes(list.bookCd)"
                      >
                        <span> [{{ item.discntRate }}% 할인] </span>
                        <span>{{ list.bookNm }}</span>
                      </option>
                    </select>
                  </span>
                </h3>
              </div>
              <div class="price_wrap">
                <ul class="meta_detail">
                  <li>
                    <p class="meta_price">
                      <strong>
                        <span v-show="item.bookCode">-</span>
                        <span v-if="item.discntTp === 'WON'">
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="price"
                            format-style="decimal"
                            :currency="getCurrency.currency"
                            :number="item.discntWon || 0"
                          />
                          원
                        </span>
                        <span v-if="item.discntTp === 'RATE'">
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="price"
                            format-style="decimal"
                            :currency="getCurrency.currency"
                            :number="
                              Math.floor(
                                getSaleAmt(item.bookCode) *
                                  (item.discntRate / 100)
                              ) || 0
                            "
                          />
                          원
                        </span>
                      </strong>
                    </p>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <!-- 위험 END -->
        <!-- DISCOUNT COUPON SECTION END-->
        <!-- ADDRESS INPUT SECTION START -->
        <div class="box">
          <div class="address_type">
            <div v-show="isGift" class="top_title">
              <p>선물 받으실 분</p>
            </div>

            <ul class="form_wrap">
              <template v-if="isGift">
                <li class="return_name">
                  <div class="name_field">
                    <p class="sub_title">
                      {{ $t('views.cart.deliveryinfo.6751') }}
                    </p>
                    <div class="input_wrap">
                      <label for="deliveryName" class="hidden">{{
                        $t('views.cart.deliveryinfo.6751')
                      }}</label>
                      <input
                        id="deliveryName"
                        v-model="deliveryName"
                        class="input_t"
                        type="text"
                        name="name"
                        :title="$t('views.cart.deliveryinfo.6751')"
                      />
                    </div>
                  </div>
                </li>
                <li class="join_phone">
                  <p class="sub_title align_top">
                    받는분<br />
                    {{ $t('views.cart.deliveryinfo.7231') }}
                  </p>

                  <!-- Mobile Phone Number -->
                  <div class="input_wrap">
                    <label>
                      <input
                        v-model="selectedMobilePrefix"
                        class="input_t fir"
                        type="number"
                        maxlength="4"
                        placeholder="010"
                        title="휴대폰 번호 첫번째 자리"
                      />
                      <span class="blind">휴대폰 번호 첫번째 자리 입력</span>
                    </label>
                    <label>
                      <input
                        v-model="mobileNumber1"
                        class="input_t mid"
                        type="number"
                        pattern="/^-?\d+\.?\d*$/"
                        onkeypress="if(this.value.length==4) return false;"
                        name="mobileNumber1"
                        maxlength="4"
                        placeholder="0000"
                        title="휴대폰 번호 두번째 자리"
                      />
                      <span class="blind">휴대폰 번호 두번째 자리 입력</span>
                    </label>
                    <label>
                      <input
                        v-model="mobileNumber2"
                        class="input_t last"
                        type="number"
                        pattern="/^-?\d+\.?\d*$/"
                        onkeypress="if(this.value.length==4) return false;"
                        name="mobileNumber2"
                        maxlength="4"
                        placeholder="0000"
                        title="휴대폰 번호 세번째 자리"
                      />
                      <span class="blind">휴대폰 번호 세번째 자리 입력</span>
                    </label>
                  </div>
                </li>
                <!-- MOBILE PHONE DETAILS -->
                <li class="join_phone">
                  <p class="sub_title align_top">
                    받는분<br />
                    EMAIL
                  </p>

                  <!-- Mobile Phone Number -->
                  <div class="input_wrap user-id-wrap">
                    <label>
                      <input
                        v-model="userId"
                        class="input_t email"
                        type="text"
                        placeholder="이메일을 입력해주세요"
                      />
                      <span class="at-ico">@</span>
                    </label>

                    <div class="select_area ml-0 email-select">
                      <div
                        :class="showInputEmail ? '' : 'hidden'"
                        class="input_wrap inputMessage"
                      >
                        <label>
                          <input
                            v-model="selectedEmail"
                            class="input_t"
                            type="text"
                            name="selectedEmail"
                            placeholder="직접입력"
                          />
                        </label>
                        <span class="arrow blind">열기</span>
                      </div>
                      <div
                        class="select_item"
                        :class="{ active: showEmailSelect }"
                      >
                        <button
                          v-on-clickaway="closeShowEmailSelectMenu"
                          class="select_option"
                          @click="toggleEmailSelectMenu"
                        >
                          <span
                            v-if="!selectedEmail || showInputEmail"
                            class="txt"
                            >이메일을 선택해주세요</span
                          >
                          <span v-else>{{ selectedEmail }}</span>
                          <span class="arrow blind">열기</span>
                        </button>
                        <ul class="select_list" data-return-check="true">
                          <li class="tit">
                            {{ selectedEmail }}
                            <button
                              type="button"
                              class="select_list_close an_a"
                            >
                              <span class="svg_close"></span>
                              <span class="an_t">닫기</span>
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              class="list_option"
                              @click="displayInputEmail"
                            >
                              <span>{{
                                $t('views.cart.deliveryinfo.2251')
                              }}</span>
                            </button>
                          </li>
                          <li v-for="(email, idx) in emailList" :key="idx">
                            <button
                              type="button"
                              class="list_option"
                              :class="{ active: selectedEmail === email }"
                              @click="selectEmail(email)"
                            >
                              <span>{{ email }}</span>
                            </button>
                          </li>
                        </ul>
                      </div>
                      <!-- .select_list 직접 입력 선택 시 .input_wrap display:block;-->
                    </div>
                  </div>
                </li>

                <!-- Landline Phone Number -->
              </template>
              <li class="amount_payment">
                <div class="top_title">
                  <p>{{ $t('views.cart.deliveryinfo.6474') }}</p>
                </div>
                <div class="total_price_wrap">
                  <div class="price_title">
                    <div
                      v-if="combinedItemList.length > 1"
                      class="title_gray"
                    ></div>
                    <div v-else class="title_gray_short"></div>
                    <span class="title_text_wrap">
                      <span
                        v-if="
                          combinedItemList.length && combinedItemList[0].bookNm
                        "
                        :title="combinedItemList[0].bookNm"
                      >
                        {{ combinedItemList[0].bookNm }}
                      </span>
                      <br />
                      <span v-if="combinedItemList.length > 1">
                        외 {{ combinedItemList.length - 1 }}권</span
                      >
                    </span>
                  </div>
                  <div class="table_wrap">
                    <div class="order_price">
                      <span class="dt">{{
                        $t('views.cart.deliveryinfo.1958')
                      }}</span>
                      <span class="dd total_price list_price">
                        <strong>
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="price"
                            format-style="decimal"
                            :currency="getCurrency.currency"
                            :number="totalOrderPrice || 0"
                          />
                          원
                        </strong>
                      </span>
                    </div>
                    <div class="order_price">
                      <span class="dt">
                        쿠폰할인금액
                      </span>
                      <span class="dd discount_price">
                        <strong>
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="price"
                            format-style="decimal"
                            :currency="getCurrency.currency"
                            :number="-selectedDiscountPrice"
                          />
                          원
                        </strong>
                      </span>
                    </div>
                    <div class="order_price">
                      <span class="dt">최종 결제금액</span>
                      <span class="dd total_price">
                        <strong>
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="price"
                            format-style="decimal"
                            :currency="getCurrency.currency"
                            :number="totalDiscountApplyPrice"
                          />
                          원
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </li>

              <!-- <li class="payment_wrap">
                <div class="top_title">
                  <p>결제 방법</p>
                </div>
                <div
                  class="box_inner payment_method_wrap"
                  data-detail="check_fl"
                >
                  <template>
                    <div v-if="isKgInicis" class="text_label">
                      <label>
                        <input
                          v-model="provider"
                          name="paymentMethod"
                          type="radio"
                          value="html_inicis_card"
                          @click="setToCard"
                        />
                        <em></em>
                        <span>카드결제</span>
                      </label>
                    </div>
                    <div
                      v-if="getCurrency.localeCd === 'ko'"
                      class="text_label"
                    >
                      <label>
                        <input
                          v-model="provider"
                          name="paymentMethod"
                          type="radio"
                          value="html_inicis_trans"
                          @click="setToTrans"
                        />
                        <em></em>
                        <span>실시간 계좌이체</span>
                      </label>
                    </div>
                  </template>
                </div>
              </li> -->
              <li class="payment_wrap">
                <TossWidget
                  :customer-name="getCurrentUser.memberNm"
                  :order-name="getOrderName"
                  :sale-amount="totalDiscountApplyPrice"
                  :is-gift="isGift"
                  :combined-item-list="combinedItemList"
                  :mobile-phone-number="mobilePhoneNumber"
                  :receiver-name="deliveryName"
                  :receiver-email="receiverEmail"
                  :discount-selected="discountSelected"
                  @validMessage="giftValideMessage"
                />
              </li>
              <!-- <li class="payment_desc">
                <span
                  >※ 페이팔 이용 시 원화 결제는 불가하오니, 좌측 하단의 언어
                  변경 후 타 통화로 결제 부탁드립니다.</span
                >
              </li> -->
            </ul>
          </div>
        </div>

        <!-- ADDRESS INPUT SECTION END -->
        <!-- <div class="box">
          <div class="check_wrap">
            <p class="guide_txt">{{ $t('views.cart.deliveryinfo.9737') }}</p>
            <div class="join_check">
              <div class="text_label">
                <label class="cursor">
                  <input
                    v-model="agreeTerms"
                    type="checkbox"
                    name="agreeTerms"
                    class="chk_agree"
                  />
                  <em></em>
                  <span ref="agreeMent" class="agree_ment"
                    >동의합니다.
                    <em class="info">(전자상거래법 제 8조 제2항)</em>
                  </span>
                </label>
              </div>
            </div>
          </div>

          <div class="btn_wrap" data-detail="btn_bottom">
            <router-link :to="{ name: 'cart' }" class="box_btn dull">
              <span class="an_t">취소</span>
            </router-link>
            <button
              class="pay_btn"
              :class="{ dull: !isValid }"
              @click="goToStep3"
            >
              결제하기
            </button>
          </div>
        </div> -->
      </div>

      <!-- Address 찾기 modal -->

      <!-- Delivery Cost Info Modal START -->
      <!-- Delivery Cost Info Modal END -->

      <!-- ERROR MODAL START -->
      <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
        <Modal v-if="showErrorModal" @close="toggleErrorModal">
          <div class="ly_pop_wrap">
            <div class="ly_pop_content ly_pop_msg ly_txt">
              <div class="ly_pop_head">
                <button
                  class="btn_ly_close svg_close"
                  @click="toggleErrorModal"
                >
                  <span>닫기</span>
                </button>
              </div>
              <div class="ly_inner">
                <p>
                  {{
                    errorMessage
                      ? errorMessage
                      : getCartErrorMessage
                      ? getCartErrorMessage
                      : ''
                  }}
                </p>
                <div class="btnWrap">
                  <button class="box_btn" @click="toggleErrorModal">
                    <span class="an_t alert">{{
                      $t('library.deletemodal.close')
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </transition>
      <!-- ERROR MODAL END -->
    </JoinWrapper>

    <JoinWrapper v-if="isMobile" page-type="cart">
      <section data-detail="cart_detail">
        <!-- #region PROGRESS BAR START -->
        <div class="cart_progress">
          <div class="progress_box">
            <p class="cell">
              <span class="fn_mont">{{
                $t('views.cart.deliveryinfo.7183')
              }}</span>
              {{ $t('views.cart.deliveryinfo.4061') }}
            </p>
          </div>
          <div class="c_icon ico_progress_arrow"></div>
          <div class="progress_box active">
            <p class="cell">
              <span class="fn_mont">{{
                $t('views.cart.deliveryinfo.2670')
              }}</span>
              {{ $t('views.cart.deliveryinfo.2037') }}
            </p>
          </div>
          <div class="c_icon ico_progress_arrow"></div>
          <div class="progress_box">
            <p class="cell">
              <span class="fn_mont">{{
                $t('views.cart.deliveryinfo.724')
              }}</span>
              {{ $t('views.cart.deliveryinfo.2648') }}
            </p>
          </div>
        </div>
        <!-- #endregion  PROGRESS BAR END -->

        <div class="box">
          <div class="top_title">
            <p class="cart2_title">{{ $t('views.cart.deliveryinfo.5916') }}</p>
            <div class="btn_wrap tar">
              <button
                type="button"
                class="more_order_book"
                :class="{ active: showAllItems }"
                @click="toggleShowAllItems"
              >
                <span class>
                  {{ showAllItems ? '전체 상품 닫기' : '전체 상품 보기' }}
                </span>
              </button>
            </div>
          </div>

          <ul v-if="getCart" class="order_book" data-detail="cart_2">
            <!-- ORDER ITEMS START -->
            <li v-for="item in formattedItemList" :key="item.cartGoodsSeq">
              <div class="cover_wrap">
                <router-link
                  :to="{
                    name: 'book_detail',
                    params: { id: item.bookCd || '0' }
                  }"
                  class="thum_wrap"
                >
                  <img :src="item.thumbUrl" alt="책제목" />
                </router-link>
              </div>

              <div class="info_wrap">
                <div class="upside">
                  <h3 class="meta_title order_info" :title="item.bookNm || ''">
                    {{ item.bookNm || '' }}
                  </h3>
                  <span
                    v-if="
                      item.listAmt > item.saleAmt ||
                      item.bookCd == 'BO-20250219000100072' || // 정신건강간호학 9판
                      item.bookCd == 'BO-20250206000100001' // 아동간호학 3판
                    "
                    style="
                      font-size: 10px;
                      color: red;
                      display: block;
                      line-height: 10px;
                    "
                  >
                    * 해당 상품은 할인쿠폰 적용이 불가능 합니다</span
                  >
                  <!-- <div class="title_gray"></div> -->
                  <h3 class="meta_title order_info">
                    상품금액
                  </h3>
                </div>
                <div class="downside">
                  <p class="book_data">
                    <span class="meta_author">{{ item.author }}</span>
                    <span class="gap">/</span>
                    <span class="meta_publisher">{{ item.publisher }}</span>
                  </p>
                  <p class="option_title">
                    <span class="option_box">옵션</span>
                    <span class="meta_total_count base_CT16">
                      {{ item.options.optDesc }}
                    </span>
                  </p>
                  <div class="price_wrap">
                    <div class="option_desc">{{ item.options.optDesc }}</div>
                    <ul class="meta_detail">
                      <li>
                        <p class="meta_price">
                          <strong v-if="item.saleAmt">
                            <vue-intl-numberformat
                              locale="ko-KR"
                              class="price"
                              format-style="decimal"
                              :currency="getCurrency.currency"
                              :number="item.saleAmt"
                            />
                            원
                          </strong>

                          <strong v-if="!item.saleAmt">
                            <vue-intl-numberformat
                              locale="ko-KR"
                              class="price"
                              format-style="decimal"
                              :currency="getCurrency.currency"
                              :number="0"
                            />
                          </strong>
                        </p>
                      </li>
                      <!-- REMOVE DELIVERY COST INFO -->
                    </ul>
                  </div>
                  <div class="discount_wrap">
                    <span>
                      <span v-if="item.listAmt > item.saleAmt" class="discount">
                        <vue-intl-numberformat
                          locale="ko-KR"
                          class="price"
                          format-style="decimal"
                          :currency="getCurrency.currency"
                          :number="item.listAmt"
                        />
                        원
                      </span>
                      <span v-if="item.listAmt > item.saleAmt" class="percent">
                        ( {{ item.discountPercent }}
                        <span class="arrow">{{
                          $t('views.cart.cart.discount')
                        }}</span>
                        )
                      </span>
                    </span>
                  </div>
                </div>

                <!-- 첫번째 주문상품에만 보이기 // 전체 상품보기 활성화 시 display:none -->
              </div>
            </li>
            <!-- ORDER ITEMS END -->
          </ul>
        </div>
        <!-- DISCOUNT COUPON SECTION START-->
        <!-- 위험 START-->
        <!-- EBOOK SECTION START -->
        <div v-if="!isGift" class="box" data-detail="margin_0">
          <div class="top_title">
            <p>할인 쿠폰</p>
            <div class="btn_wrap tar">
              <button
                type="button"
                class="more_order_book"
                :class="{ active: showAllCoupons }"
                @click="toggleShowAllCoupons"
              >
                <span class>
                  {{ showAllCoupons ? '쿠폰 목록 닫기' : '쿠폰 목록 보기' }}
                </span>
              </button>
            </div>
          </div>
          <!-- EBOOK LIST SECTION START -->
          <ul
            v-if="combinedItemList && showAllCoupons"
            class="order_book"
            data-detail="cart_3"
          >
            <li
              v-for="(item, index) in safeDiscntList"
              :key="`${item.discntSeq}`"
              class="join_check"
            >
              <div class="text_label">
                <label>
                  <input
                    v-model="discountSelected"
                    type="checkbox"
                    name="agree"
                    class=""
                    :title="item.bookName + `선택`"
                    :value="{
                      bookCode: item.bookCode,
                      discountWon: item.discntWon || 0,
                      discountRate: item.discntRate || 0,
                      discountSeq: item.discntSeq,
                      discountTp: item.discntTp
                    }"
                    :disabled="
                      item.bookCode === undefined || item.bookCode === ''
                    "
                    @change="checkDuplicate(item.bookCode)"
                  />
                  <em></em>
                  <span>{{ item.bookName }}선택</span>
                </label>
              </div>

              <div class="info_wrap">
                <div
                  class="cover_wrap"
                  :class="{ hidden: getThumbIndex(item) < 0 }"
                >
                  <router-link
                    :to="{
                      name: 'book_detail',
                      params: { id: item.bookCode || '0' }
                    }"
                    class="thum_wrap"
                  >
                    <img
                      v-if="getThumbIndex(item) >= 0"
                      :src="combinedItemList[getThumbIndex(item)].thumbUrl"
                      alt="책제목"
                    />
                  </router-link>
                </div>
                <h3 class="meta_title">
                  <span v-if="item.bookName">
                    <span class="coupon_book">{{ item.bookName }}</span>
                    <span v-if="item.discntTp === 'WON'" class="coupon_info">
                      {{ item.discntWon }}원 할인쿠폰
                    </span>
                    <span v-if="item.discntTp === 'RATE'" class="coupon_info">
                      {{ item.discntRate }}% 할인쿠폰
                    </span>
                  </span>
                  <span v-if="!item.bookName">
                    <select
                      v-model="selectedEmptyCoupon[index]"
                      @change="changeSelectCoupon(item, index)"
                    >
                      <option value="">
                        이곳을 클릭하여 도서를 선택해 주세요
                      </option>
                      <option
                        v-for="list in filteredCombinedItemList"
                        :key="list.idx"
                        :value="list.bookCd"
                        :disabled="selectedEmptyCoupon.includes(list.bookCd)"
                      >
                        <span> [{{ item.discntRate }}% 할인] </span>
                        <span>{{ list.bookNm }}</span>
                      </option>
                    </select>
                  </span>
                </h3>
              </div>
              <div class="price_wrap">
                <ul class="meta_detail">
                  <li>
                    <p class="meta_price">
                      <strong>
                        <span v-show="item.bookCode">-</span>
                        <span v-if="item.discntTp === 'WON'">
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="price"
                            format-style="decimal"
                            :currency="getCurrency.currency"
                            :number="item.discntWon || 0"
                          />
                          원
                        </span>
                        <span v-if="item.discntTp === 'RATE'">
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="price"
                            format-style="decimal"
                            :currency="getCurrency.currency"
                            :number="
                              Math.floor(
                                getSaleAmt(item.bookCode) *
                                  (item.discntRate / 100)
                              ) || 0
                            "
                          />
                          원
                        </span>
                      </strong>
                    </p>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <!-- 위험 END -->
        <!-- DISCOUNT COUPON SECTION END-->
        <!-- ADDRESS INPUT SECTION START -->
        <div class="box">
          <div class="address_type">
            <div v-show="isGift" class="top_title">
              <p>선물 받으실 분</p>
            </div>

            <ul class="form_wrap">
              <template v-if="isGift">
                <li class="return_name">
                  <div class="name_field">
                    <p class="sub_title">
                      {{ $t('views.cart.deliveryinfo.6751') }}
                    </p>
                    <div class="input_wrap">
                      <label for="deliveryName" class="hidden">{{
                        $t('views.cart.deliveryinfo.6751')
                      }}</label>
                      <input
                        id="deliveryName"
                        v-model="deliveryName"
                        class="input_t wid"
                        type="text"
                        name="name"
                        :title="$t('views.cart.deliveryinfo.6751')"
                      />
                    </div>
                  </div>
                </li>
                <li class="join_phone">
                  <p class="sub_title align_top">
                    받는분<br />
                    {{ $t('views.cart.deliveryinfo.7231') }}
                  </p>

                  <!-- Mobile Phone Number -->
                  <div class="input_wrap">
                    <label>
                      <input
                        v-model="selectedMobilePrefix"
                        class="input_t"
                        type="number"
                        maxlength="4"
                        placeholder="010"
                        title="휴대폰 번호 첫번째 자리"
                      />
                      <span class="blind">휴대폰 번호 첫번째 자리 입력</span>
                    </label>
                    <label>
                      <input
                        v-model="mobileNumber1"
                        class="input_t"
                        type="number"
                        pattern="/^-?\d+\.?\d*$/"
                        onkeypress="if(this.value.length==4) return false;"
                        name="mobileNumber1"
                        maxlength="4"
                        placeholder="0000"
                        title="휴대폰 번호 두번째 자리"
                      />
                      <span class="blind">휴대폰 번호 두번째 자리 입력</span>
                    </label>
                    <label>
                      <input
                        v-model="mobileNumber2"
                        class="input_t"
                        type="number"
                        pattern="/^-?\d+\.?\d*$/"
                        onkeypress="if(this.value.length==4) return false;"
                        name="mobileNumber2"
                        maxlength="4"
                        placeholder="0000"
                        title="휴대폰 번호 세번째 자리"
                      />
                      <span class="blind">휴대폰 번호 세번째 자리 입력</span>
                    </label>
                  </div>
                </li>
                <!-- MOBILE PHONE DETAILS -->
                <li class="join_phone">
                  <p class="sub_title align_top">
                    받는분<br />
                    EMAIL
                  </p>

                  <!-- Mobile Phone Number -->
                  <div class="input_wrap user-id-wrap">
                    <label>
                      <input
                        v-model="userId"
                        class="input_t wid"
                        type="text"
                        placeholder="이메일을 입력해주세요"
                      />
                      <span class="at-ico">@</span>
                    </label>

                    <div class="select_area ml-0 email-select">
                      <div
                        :class="showInputEmail ? '' : 'hidden'"
                        class="input_wrap inputMessage"
                      >
                        <label>
                          <input
                            v-model="selectedEmail"
                            class="input_t"
                            type="text"
                            name="selectedEmail"
                            placeholder="직접입력"
                          />
                        </label>
                        <span class="arrow blind">열기</span>
                      </div>

                      <div
                        class="select_item"
                        :class="{ active: showEmailSelect }"
                      >
                        <button
                          v-on-clickaway="closeShowEmailSelectMenu"
                          class="select_option"
                          @click="toggleEmailSelectMenu"
                        >
                          <span
                            v-if="!selectedEmail || showInputEmail"
                            class="txt"
                            >이메일을 선택해주세요</span
                          >
                          <span v-else>{{ selectedEmail }}</span>
                          <span class="arrow blind">열기</span>
                        </button>
                        <ul class="select_list" data-return-check="true">
                          <li class="tit">
                            {{ selectedEmail }}
                            <button
                              type="button"
                              class="select_list_close an_a"
                            >
                              <span class="svg_close"></span>
                              <span class="an_t">닫기</span>
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              class="list_option"
                              @click="displayInputEmail"
                            >
                              <span>{{
                                $t('views.cart.deliveryinfo.2251')
                              }}</span>
                            </button>
                          </li>
                          <li v-for="(email, idx) in emailList" :key="idx">
                            <button
                              type="button"
                              class="list_option"
                              :class="{ active: selectedEmail === email }"
                              @click="selectEmail(email)"
                            >
                              <span>{{ email }}</span>
                            </button>
                          </li>
                        </ul>
                      </div>
                      <!-- .select_list 직접 입력 선택 시 .input_wrap display:block;-->
                    </div>
                  </div>
                </li>

                <!-- Landline Phone Number -->
              </template>
              <li class="amount_payment">
                <div class="top_title">
                  <p>{{ $t('views.cart.deliveryinfo.6474') }}</p>
                </div>
                <div class="total_price_wrap">
                  <div class="price_title">
                    <div
                      v-if="combinedItemList.length > 1"
                      class="title_gray"
                    ></div>
                    <div v-else class="title_gray_short"></div>
                    <span class="title_text_wrap">
                      <span
                        v-if="
                          combinedItemList.length && combinedItemList[0].bookNm
                        "
                        :title="combinedItemList[0].bookNm"
                      >
                        {{ combinedItemList[0].bookNm }}
                      </span>
                      <br />
                      <span v-if="combinedItemList.length > 1">
                        외 {{ combinedItemList.length - 1 }}권</span
                      >
                    </span>
                  </div>
                  <div class="table_wrap">
                    <div class="order_price">
                      <span class="dt">{{
                        $t('views.cart.deliveryinfo.1958')
                      }}</span>
                      <span class="dd total_price list_price">
                        <strong>
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="price"
                            format-style="decimal"
                            :currency="getCurrency.currency"
                            :number="totalOrderPrice || 0"
                          />
                          원
                        </strong>
                      </span>
                    </div>
                    <div class="order_price">
                      <span class="dt">
                        쿠폰할인금액
                      </span>
                      <span class="dd discount_price">
                        <strong>
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="price"
                            format-style="decimal"
                            :currency="getCurrency.currency"
                            :number="-selectedDiscountPrice"
                          />
                          원
                        </strong>
                      </span>
                    </div>
                    <div class="order_price">
                      <span class="dt">최종 결제금액</span>
                      <span class="dd total_price">
                        <strong>
                          <vue-intl-numberformat
                            locale="ko-KR"
                            class="price"
                            format-style="decimal"
                            :currency="getCurrency.currency"
                            :number="totalDiscountApplyPrice"
                          />
                          원
                        </strong>
                      </span>
                    </div>
                  </div>
                </div>
              </li>

              <li class="payment_wrap">
                <TossWidget
                  :customer-name="getCurrentUser.memberNm"
                  :order-name="getOrderName"
                  :sale-amount="totalDiscountApplyPrice"
                  :is-gift="isGift"
                  :combined-item-list="combinedItemList"
                  :discount-selected="discountSelected"
                  @validMessage="giftValideMessage"
                />
              </li>
              <!-- <li class="payment_desc">
                <span
                  >※ 페이팔 이용 시 원화 결제는 불가하오니, 좌측 하단의 언어
                  변경 후 타 통화로 결제 부탁드립니다.</span
                >
              </li> -->
            </ul>
          </div>
        </div>

        <!-- ADDRESS INPUT SECTION END -->
        <div class="box">
          <!-- <div class="check_wrap">
            <p class="guide_txt">{{ $t('views.cart.deliveryinfo.9737') }}</p>
            <div class="join_check">
              <div class="text_label">
                <label class="cursor">
                  <input
                    v-model="agreeTerms"
                    type="checkbox"
                    name="agreeTerms"
                    class="chk_agree"
                  />
                  <em></em>
                  <span ref="agreeMent" class="agree_ment"
                    >동의합니다.
                    <em class="info">(전자상거래법 제 8조 제2항)</em>
                  </span>
                </label>
              </div>
            </div>
          </div> -->

          <!-- <div class="btn_wrap" data-detail="btn_bottom">
            <router-link :to="{ name: 'cart' }" class="box_btn dull">
              <span class="an_t">취소</span>
            </router-link>
            <button
              class="pay_btn"
              :class="{ dull: !isValid }"
              @click="goToStep3"
            >
              결제하기
            </button>
          </div> -->
        </div>
      </section>

      <!-- Address 찾기 modal -->
      <!-- <SearchAddressModal
        v-if="showAddressModal"
        @complete="onComplete"
        @close="toggleAddressModal"
      /> -->

      <!-- Delivery Cost Info Modal START -->
      <!-- <transition v-on-clickaway="toggleDeliveryModal" name="modal-fade">
        <Modal v-if="showDeliveryModal" @close="toggleDeliveryModal">
          <div class="ly_pop_wrap">
            <div class="ly_pop_content ly_pop_msg ly_txt">
              <div class="ly_pop_head">
                <button
                  class="btn_ly_close svg_close"
                  @click="toggleDeliveryModal"
                >
                  <span>닫기</span>
                </button>
              </div>
              <div class="ly_inner">
                <strong>{{ $t('views.cart.deliveryinfo.8551') }}</strong>
                <p style="white-space: pre;">
                  {{ $t('views.cart.deliveryinfo.9242') }}<br />{{
                    $t('views.cart.deliveryinfo.3019', {
                      '1': getCart.shippingFee.paperbook.toLocaleString('ko-kr')
                    })
                  }}<br />{{ $t('views.cart.deliveryinfo.8867') }}<br />
                </p>
                <br />
                <p style="white-space: pre;">
                  {{ $t('views.cart.deliveryinfo.pod') }}<br />{{
                    $t('views.cart.deliveryinfo.995', {
                      '1': getCart.shippingFee.pod.toLocaleString('ko-kr')
                    })
                  }}<br />{{ $t('views.cart.deliveryinfo.3587') }}<br />
                </p>
              </div>
            </div>
          </div>
        </Modal>
      </transition> -->
      <!-- Delivery Cost Info Modal END -->

      <!-- ERROR MODAL START -->
      <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
        <Modal v-if="showErrorModal" @close="toggleErrorModal">
          <div class="ly_pop_wrap">
            <div class="ly_pop_content ly_pop_msg ly_txt">
              <div class="ly_pop_head">
                <button
                  class="btn_ly_close svg_close"
                  @click="toggleErrorModal"
                >
                  <span>닫기</span>
                </button>
              </div>
              <div class="ly_inner">
                <p>
                  {{
                    errorMessage
                      ? errorMessage
                      : getCartErrorMessage
                      ? getCartErrorMessage
                      : ''
                  }}
                </p>
                <div class="btnWrap">
                  <button class="box_btn" @click="toggleErrorModal">
                    <span class="an_t alert">{{
                      $t('library.deletemodal.close')
                    }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </transition>
      <!-- ERROR MODAL END -->
    </JoinWrapper>

    <Iamport />
  </div>
</template>

<script>
import JoinWrapper from '@/components/auth/JoinWrapper.vue'
import { baseUri } from '@/store/constants'
import { mapGetters } from 'vuex'
import TossWidget from '@/components/common/TossPaymentWidget.vue'

import {
  CART_GET_LIST,
  CART_CREATE_ORDER,
  CART_GET_DISCOUNT_LIST
} from '@/store/types'

export default {
  name: 'DeliveryInfo',
  components: {
    // SearchAddressModal,
    JoinWrapper,
    TossWidget
  },
  data() {
    return {
      userId: '',
      showAllItems: true,
      showAllCoupons: true,
      selectedItems: null,
      defaultAddress: false,
      // Validation
      agreeTerms: false,
      invalidPhone: '',

      // v-models
      addressTemplate: 'new',
      deliveryName: '',
      paymentMethod: 'card',
      provider: 'html_inicis_card',
      selectedEmail: '',
      selectedCountry: 'South Korea',
      selectedCountryCode: '82',
      selectedMobilePrefix: '010',
      mobileNumber1: '',
      mobileNumber2: '',
      selectedPhonePrefix: '',
      phoneNumber1: '',
      phoneNumber2: '',
      emailList: ['naver.com', 'daum.net', 'nate.com', 'pubple.com'],

      showEmailSelect: false,
      showInputEmail: false,
      showErrorModal: false,
      errorMessage: '',

      deliveryTp: 'K',
      orderTotalWeight: 0,
      globalDeliveryFee: 0,

      // 추가
      // allSelected: false,
      discountSelected: [],
      discountList: {
        discntList: [{}],
        discntCount: 0
      },
      selectedEmptyCoupon: [''],
      isPc: false,
      isMobile: false
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.setupPage()
    next()
  },

  computed: {
    ...mapGetters([
      'getCurrency',
      'isCartLoading',
      'getCart',
      'getCurrentUser',
      'getCartDefaultAddress',
      'getCartErrorMessage',
      'getDiscountItems'
    ]),
    safeDiscntList() {
      return this.discountList?.discntList || []
    },
    isGiftValid() {
      return (
        this.userId &&
        this.mobilePhoneNumber &&
        this.userId &&
        this.selectedEmail
      )
    },
    isKgInicis() {
      if (this.getCurrency.mode.indexOf('html_inicis') >= 0) {
        return true
      }
      return false
    },
    totalPrice() {
      if (!this.getCart || !this.combinedItemList) {
        return 0
      }
      return this.combinedItemList.reduce((total, item) => {
        return total + (item.saleAmt || 0)
      }, 0)
    },
    currencySeq() {
      return this.formattedItemList[0].currencies.find((e) => {
        return e.currencyTp === this.getCurrency.currency
      }).currencyRevSeq
    },
    totalOrderPrice() {
      return Number(this.totalPrice.toFixed(2))
    },
    formattedItemList() {
      if (this.showAllItems) {
        return this?.combinedItemList || []
      } else {
        return this.combinedItemList.length ? [this.combinedItemList[0]] : []
      }
    },
    ebookItemList() {
      if (!this.getCart || !this.selectedItems || !this.selectedItems.ebook)
        return []

      let combined = []

      this.selectedItems.ebook.map((seq) => {
        const item = this.getCart.ebookCartList.find(
          (i) => i.cartGoodsSeq === seq
        )
        combined.push(item)
      })

      return combined
    },
    giftItemList() {
      if (!this.getCart || !this.selectedItems || !this.selectedItems.gift)
        return []

      let combined = []

      this.selectedItems.gift.map((seq) => {
        const item = this.getCart.giftCartList.find(
          (i) => i.cartGoodsSeq === seq
        )
        combined.push(item)
      })

      return combined
    },
    combinedItemList() {
      if (!this.getCart || !this.selectedItems) return []

      return [...this.ebookItemList, ...this.giftItemList]
    },
    filteredCombinedItemList() {
      return this.combinedItemList.filter(
        (list) =>
          list.listAmt <= list.saleAmt &&
          list.bookCd !== 'BO-20250219000100072' &&
          list.bookCd !== 'BO-20250206000100001' // 정신건강간호학 9판 , 아동간호학 3판
      )
    },
    onlyEbook() {
      return true
    },
    isGift() {
      return !!this.giftItemList.length > 0
    },
    mobilePhoneNumber() {
      if (this.addressTemplate === 'existing') {
        return this.getCartDefaultAddress
          ? this.getCartDefaultAddress.mobileNo
          : ''
      }
      if (this.selectedMobilePrefix && this.mobileNumber1 && this.mobileNumber2)
        return `${this.selectedMobilePrefix}-${this.mobileNumber1}-${this.mobileNumber2}`
      return ''
    },
    isValid() {
      if (this.addressTemplate === 'existing') {
        return true
      }
      if ((this.deliveryName && this.mobilePhoneNumber) || this.onlyEbook)
        return true
      return false
    },
    isDiscountValid() {
      if (this.getDiscountItems) {
        // console.log('loglog')
      }
      const list = []
      if (this.discountList !== null) {
        this.discountList?.discntList.forEach((e) => {
          this.combinedItemList.forEach((item) => {
            if (e.bookCode === item.bookCd) {
              list.push(item)
            }
          })
        })
      }
      return list
    },
    selectedDiscountPrice() {
      if (!this.discountSelected) {
        return 0
      }
      return this.discountSelected.reduce((total, data) => {
        if (data) {
          let dc = 0
          if (data.discountTp === 'RATE') {
            this.combinedItemList.forEach((item) => {
              if (item.bookCd === data.bookCode) {
                dc = Math.floor((item.saleAmt * data.discountRate) / 100)
              }
            })
          } else {
            dc = data.discountWon
          }
          return total + dc
        } else {
          return total
        }
      }, 0)
    },
    totalDiscountApplyPrice() {
      let result = this.totalOrderPrice - this.selectedDiscountPrice
      return result
    },
    receiverEmail() {
      return `${this.userId}@${this.selectedEmail}`
    },
    getOrderName() {
      let result = this.combinedItemList[0]?.bookNm //.concat('ㅤ') // U+3164  e3 85 a4
      if (this.combinedItemList.length > 1) {
        result = result
          .concat(' 외')
          .concat(this.combinedItemList.length - 1)
          .concat('건')
      }
      return result
    }
  },
  watch: {
    addressTemplate(e) {
      if (e === 'new') {
        this.deliveryTp = 'K'
      }
    },
    provider(nw) {
      if (nw === 'html_inicis') return
      if (nw === 'html_inicis_card' || nw === 'html_inicis_trans') {
        this.provider = 'html_inicis'
      }
    },
    deliveryTp(e, old) {
      this.globalDeliveryFee = 0
      if (e === old) {
        return
      }
      if (this.addressTemplate === 'existing') {
        return
      }
    },
    isDiscountValid: {
      deep: true,
      handler() {
        this.discountList = this.getDiscountItems
      }
    }
  },
  async mounted() {
    this.checkWindowSize()
    window.addEventListener('resize', this.checkWindowSize)
    if (this.$refs.agreeMent) {
      this.$refs.agreeMent.classList.remove('style')
    }
    this.setupPage()
    // 여기에 api 호출
    if (!this.isGift && this.combinedItemList.length > 0) {
      const bookList = this.combinedItemList
      let bookCds = []
      bookList.forEach((e) => {
        bookCds.push(e.bookCd)
      })

      this.$store.dispatch(CART_GET_DISCOUNT_LIST, {
        data: {
          discount: {
            bookCd: bookCds
          }
        }
      })
    }
    if (!this.orderTotalWeight && this.formattedItemList) {
      this.formattedItemList.forEach((e) => {
        if (e.goodsOptTp !== 'EBOOK')
          this.orderTotalWeight += e.totalBookWeight || 0
      })
    }
    this.discountList = this.getDiscountItems
    this.discountList?.discntList.forEach((e) => {
      if (!e.bookName) {
        this.selectedEmptyCoupon.push('')
      }
    })
  },
  methods: {
    checkWindowSize() {
      this.isPc = window.innerWidth >= 481
      this.isMobile = window.innerWidth <= 480
    },
    setToCard() {
      this.paymentMethod = 'card'
    },
    setToTrans() {
      this.paymentMethod = 'trans'
    },
    setupPage() {
      if (!this.$route.params.selectedItems) {
        this.$router.push({ name: 'cart' })
        return
      } else {
        this.selectedItems = this.$route.params.selectedItems
      }
      if (!this.getCart) {
        this.$store.dispatch(CART_GET_LIST)
      }
      if (this.onlyEbook) {
        return
      }
    },
    toggleShowAllItems() {
      this.showAllItems = !this.showAllItems
    },
    toggleShowAllCoupons() {
      this.showAllCoupons = !this.showAllCoupons
    },
    toggleEmailSelectMenu() {
      this.showEmailSelect = !this.showEmailSelect
    },
    closeShowEmailSelectMenu() {
      this.showEmailSelect = false
    },
    selectEmail(value) {
      this.selectedEmail = value
      this.showInputEmail = false
    },
    displayInputEmail() {
      this.showInputEmail = true
      this.showEmailSelect = false
      this.selectedEmail = ''
    },
    mobileBaseUri() {
      let x = baseUri
      let z = x.charAt(x.length - 1)
      if (z == '/') {
        return baseUri.concat('purchase/complete')
      } else if (z !== '/') {
        return baseUri.concat('/purchase/complete')
      }
    },
    toggleErrorModal(message) {
      if (message) {
        this.errorMessage = message
      }
      this.showErrorModal = !this.showErrorModal
    },
    async goToStep3() {
      if (
        !this.agreeTerms ||
        !this.isValid
        // !this.isGlobalSelectAddressValid
      ) {
        this.showErrorModal = !this.showErrorModal
        this.errorMessage = this.$t('views.member.orderdetail.fillout')
        // if (!this.agreeTerms) {
        //   this.$refs.agreeMent.classList.add('style')
        // }
        return
      }

      if (this.isCartLoading) {
        return
      }
      if (this.isGift) {
        let emailValid = /\S+@\S+\.\S+/
        let koreanValid = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/
        let numValid = /[0-9]/
        let spcValid = /^(?=.*[~!@#$%^&*()_+|.,'";<>?:{}])/gi
        if (!this.isGiftValid) {
          this.showErrorModal = !this.showErrorModal
          this.errorMessage = '모든 정보를 입력해주세요.'
          return
        }
        if (
          !emailValid.test(`${this.userId}@${this.selectedEmail}`) ||
          koreanValid.test(`${this.selectedEmail}`)
        ) {
          this.showErrorModal = !this.showErrorModal
          this.errorMessage =
            '올바르지 않은 이메일 양식 입니다.선물 받을 분의 이메일 주소를 다시 확인하여 입력해주세요.'

          return false
        }
        if (
          numValid.test(this.deliveryName) ||
          spcValid.test(this.deliveryName)
        ) {
          this.showErrorModal = !this.showErrorModal
          this.errorMessage = '이름은 한글과 영어로만 입력이 가능합니다.'

          return false
        }
        if (this.selectedMobilePrefix.charAt(0) !== '0') {
          this.showErrorModal = !this.showErrorModal
          this.errorMessage =
            '올바르지 않은 연락처 입니다. 선물 받을 분의 연락처를 다시 확인하여 입력해주세요.'
          return
        }
      }

      const that = this

      /* TODO: @stan
        Currently paymentMethod of 'vbank' (가상계좌) not working
        error_code: "1122"
        error_msg: "다날 서버로부터 받은 응답이 올바르지 않습니다.등록되지 않은 가맹점 입니다."

        Currently paymentMethod of 'trans' (실시간계좌이체) not working
        error_code: "1106"
        error_msg: "다날 서버로부터 받은 응답이 올바르지 않습니다.등록되지 않은 가맹점 입니다."

        Currently paymentMethod of 'phone' (휴대폰소액결제) not working
        error_code: N/A
        error_msg: "다날 서버로부터 받은 응답이 올바르지 않습니다.undefined."
      */

      const order = {
        purchase: {
          orders: {
            procTp: 'PP',
            purchaseTp: this.isGift ? 'GFT' : 'PMT',
            // saleAmt: this.totalPrice,
            saleAmt: this.totalDiscountApplyPrice,
            currencyRevSeq: this.currencySeq,
            deliveryMsg: '',
            giftBook: this.isGift
              ? {
                  name: this.deliveryName,
                  mobileNo: this.mobilePhoneNumber,
                  email: `${this.userId}@${this.selectedEmail}`
                }
              : {
                  name: undefined,
                  mobileNo: undefined,
                  email: undefined
                },
            shippingFee: {
              paperbook: 0,
              pod: 0
            },
            payment: {
              payMethod: this.paymentMethod,
              // paidAmt: this.totalOrderPrice,
              paidAmt: this.totalDiscountApplyPrice,
              // merchantId,
              provider: this.provider || 'html_inicis',
              tid: null,
              applyNum: null
            },
            selectedCart: [],
            detail: {
              discountSelected: this.discountSelected
            }
          }
        }
      }

      const formattedCartList = {}

      this.combinedItemList.map((cartItem) => {
        if (!formattedCartList[cartItem.cartCd]) {
          formattedCartList[cartItem.cartCd] = [cartItem.cartGoodsSeq]
        } else {
          formattedCartList[cartItem.cartCd].push(cartItem.cartGoodsSeq)
        }
      })

      Object.keys(formattedCartList).map((key) => {
        order.purchase.orders.selectedCart.push({
          cartCd: key,
          cartGoodsSeqList: formattedCartList[key]
        })
      })

      /* Recording initial order transaction */
      const payload = {
        pg: this.provider || 'html_inicis',
        // pg: 'html_inicis',
        pay_method: this.paymentMethod,
        currency: this.getCurrency.currency,
        language:
          this.provider === 'paypal'
            ? this.getCurrency.paypalCd
            : localStorage.getItem('lang') || 'ko',
        // 테스트
        merchant_uid: '',
        name: 'Ealice 책',
        // amount: this.totalOrderPrice,
        amount: this.totalDiscountApplyPrice,
        buyer_email: this.getCurrentUser.username,
        buyer_name: this.getCurrentUser.memberNm,
        buyer_tel: this.mobilePhoneNumber,
        buyer_addr: null,
        buyer_postcode: null,
        /* TODO:  notifying event for Mobile.Web (brian.ohk@pubple.com) */
        m_redirect_url: this.mobileBaseUri()
      }
      try {
        const response = await this.$store.dispatch(CART_CREATE_ORDER, order)

        payload.name =
          response.data.result.orderCd /* [updated] 명세서 title 목적으로 사용 */

        payload.merchant_uid =
          response.data.result.merchantId /* [updated] 서버에서 내려준 merchantId를 사용 */
        // }
      } catch (err) {
        if (err.response) {
          this.toggleErrorModal(`${err.response.data.errorState.message}`)
        }
        return
      }

      /* For testing go to next page as success */
      window.IMP.request_pay(payload, async (rsp) => {
        order.purchase.orders.payment.tid = rsp.imp_uid
        order.purchase.orders.payment.applyNum = rsp.apply_num
        order.purchase.orders.payment.merchantId = rsp.merchant_uid
        order.purchase.orders.procTp = 'PG'

        try {
          await that.$store.dispatch(CART_CREATE_ORDER, order)
          // // Reload cart
          await that.$store.dispatch(CART_GET_LIST)
          that.$router.push({
            name: 'order_successful',
            params: {
              isGift: this.isGift
            }
          })
        } catch (err) {
          that.toggleErrorModal(`${err.response.data.errorState.message}`)
        }
      })
    },
    checkDuplicate(param) {
      let tmpList = []
      let maxIndex = this.discountSelected.length - 1
      this.discountSelected.forEach((e, index) => {
        if (e.bookCode === param && index < maxIndex) {
          this.discountSelected = []
          this.discountSelected = tmpList
        } else {
          tmpList.push(e)
        }
      })
    },
    getThumbIndex(param) {
      let result
      if (!param.bookCode) {
        return -1
      } else {
        this.combinedItemList.forEach((item, index) => {
          if (item.bookCd === param.bookCode) {
            result = index
          }
        })
      }
      return result
    },
    changeSelectCoupon(item, index) {
      let tmpList = []
      this.discountSelected.forEach((e) => {
        if (item.discntSeq === e.discountSeq) {
          this.discountSelected = []
          this.discountSelected = tmpList
        } else {
          tmpList.push(e)
        }
      })
      item.bookCode = this.selectedEmptyCoupon[index]
      if (item.bookCode != '') {
        this.discountSelected.push({
          bookCode: item.bookCode,
          discountWon: item.discntWon || 0,
          discountRate: item.discntRate || 0,
          discountSeq: item.discntSeq,
          discountTp: item.discntTp
        })
        this.checkDuplicate(item.bookCode)
      }
    },
    getSaleAmt(bookCode) {
      let saleAmt
      this.combinedItemList.forEach((e) => {
        if (e.bookCd === bookCode) {
          saleAmt = e.saleAmt
        }
      })
      return saleAmt
    },
    giftValideMessage(msg) {
      this.showErrorModal = !this.showErrorModal
      this.errorMessage = msg
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';
.fir,
.mid,
.last,
.email {
  width: 100%;
}
.delivery_list {
  .select_list {
    max-height: 680px;
    overflow: auto;
  }
}
.email-select {
  width: 100%;
  max-width: 198px;
}
.paymentModal {
  position: absolute;
  z-index: 999999;
  background-color: rgba(255, 255, 255, 0.9);
  top: -139px;
  left: 10px;
  width: 400px;
  height: 140px;
  display: flex;
  border-radius: 25px;
  box-shadow: -2px 10px 30px -24px black;
  transition: all 0.2s;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  span {
    margin-top: 25px;
    padding: 4px 8px;
    box-sizing: border-box;
    cursor: pointer;
  }
}
// kb에러모달
.btnWrap {
  padding: 0px 25px 25px 25px;
  // margin-top: 50px;
  .box_btn {
    width: 50%;
  }
}
.text_label {
  label {
    display: flex;
    align-items: center;
  }
}
.ly_inner {
  padding: 22px 25px 0px 25px !important;
}

.payment_method {
  user-select: none;
  transition: $ease;
  width: 125px;
  padding-left: 10px;
  position: relative;
  top: -3px;
  border-radius: 8px;
}

.address_wrapper {
  margin: 20px 0 80px 0 !important;
}

.address_sub {
  font-size: 16px;
  line-height: 24px;
  color: #000;
  font-weight: 500;
  margin-right: 10px;
}

.address_title {
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 24px;
  color: #778899;
}
.sub_title > img {
  width: 15px;
  height: 15px;
  position: absolute;
  left: -15px;
  top: -15px;
}
.select_area,
.select_item,
.select_option {
  width: 100%;
}

.select_area {
  margin-top: 10px;
  margin-bottom: 10px;
}

.input_prefix {
  width: 110px;
}

.country_list {
  width: 100%;
  margin-bottom: 10px;
}

.country_dropdown {
  width: 100%;
}
:disabled {
  background-color: #efefef;
  border-color: #efefef;
}
// .inputMessage {
//   width: 100% !important;
// }
.svg_q {
  background-image: url("data:image/svg+xml,%3Csvg width='13' height='13' viewBox='0 0 13 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='6.5' cy='6.5' r='6.5' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M6.5 13C10.0899 13 13 10.0899 13 6.5C13 2.91015 10.0899 0 6.5 0C2.91015 0 0 2.91015 0 6.5C0 10.0899 2.91015 13 6.5 13ZM6.5 12.1875C9.64112 12.1875 12.1875 9.64112 12.1875 6.5C12.1875 3.35888 9.64112 0.8125 6.5 0.8125C3.35888 0.8125 0.8125 3.35888 0.8125 6.5C0.8125 9.64112 3.35888 12.1875 6.5 12.1875Z' fill='%23999999'/%3E%3Cpath d='M5.89992 7.85231H6.84725C6.6878 6.43326 8.35735 5.91898 8.35735 4.5285C8.35735 3.41422 7.59761 2.78564 6.50959 2.78564C5.73109 2.78564 5.10266 3.1666 4.64307 3.69993L5.25273 4.26183C5.56226 3.90945 5.94682 3.68088 6.38766 3.68088C6.97856 3.68088 7.30685 4.08088 7.30685 4.60469C7.30685 5.64279 5.67481 6.25231 5.89992 7.85231ZM6.38766 10.2142C6.79097 10.2142 7.10988 9.89993 7.10988 9.45231C7.10988 9.00469 6.79097 8.67136 6.38766 8.67136C5.97496 8.67136 5.66543 9.00469 5.66543 9.45231C5.66543 9.89993 5.97496 10.2142 6.38766 10.2142Z' fill='black'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  display: inline-block;
  vertical-align: middle;
  width: 13px;
  height: 16px;
  margin-left: 5px;
  text-indent: -9999px;
  color: rgba(0, 0, 0, 0);
  cursor: pointer;
}
.return_name {
  display: flex;
  .name_field {
    flex: 1;
  }
  .address_check {
    flex: 10;
    margin-left: 25px;
    margin-top: 8px;

    em {
      position: relative;
      display: inline-block;
      width: 32px;
      height: 32px;
      background: #ffffff;
      border-radius: 3px;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: 20px 14px;
      background-image: url("data:image/svg+xml,%3Csvg width='20' height='14' viewBox='0 0 20 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath opacity='0.2' d='M19 1.57602L7.13322 13.2759C7.06177 13.3469 6.97677 13.4033 6.88311 13.4417C6.78945 13.4802 6.68899 13.5 6.58753 13.5C6.48607 13.5 6.38561 13.4802 6.29196 13.4417C6.1983 13.4033 6.11329 13.3469 6.04184 13.2759L1 8.30494L2.09137 7.22892L6.58753 11.6467L17.9086 0.5L19 1.57602Z' fill='%23778899' stroke='%23778899' stroke-width='0.5'/%3E%3C/svg%3E%0A");
      background-color: #f0f5fa;
    }

    span {
      color: #000000;
      line-height: 32px;
      margin-left: 10px;
      font-family: 'Montserrat', 'Noto Sans KR';
      font-size: 15px;
      vertical-align: top;
    }
  }
}
.global_address_wrap .input_wrap {
  display: flex;
  flex-direction: column;
  .input_t {
    width: 100%;
    margin-bottom: 16px;
  }
  .text_label input + em::before {
    border: none;
  }
  .select_area:nth-child(1) {
    margin-top: 0px;
    margin-bottom: 15px;
  }
  .select_area_list {
    width: 100%;
    height: 48px;
    border: 1px solid #d5dff3;
    border-radius: 12px;
    display: flex;
    align-items: center;
  }
}
.at-ico {
  margin: 0px 12px;
  float: left;
  height: 48px;
  display: inline-flex;
  align-items: center;
}
.select_item.active .select_list {
  width: 100%;
}
.form_wrap {
  .return_name,
  .return_name > .name_field,
  .join_phone {
    padding: 0;
    display: flex;
    align-items: center;
    .input_wrap {
      display: flex;
      // justify-content: flex-start;
      width: 100%;
      label {
        max-width: 128px;
        width: 100%;
        margin-right: 16px;
      }
    }
    .user-id-wrap {
      label {
        display: flex;
        // max-width: 268px;
        max-width: 210px;
        margin: 0;
      }

      .select_item {
        max-width: 190px;
      }
    }
    .sub_title {
      margin: 0;
      min-width: 98px;
      position: static;
    }
  }
}
.email-select {
  display: flex;
  max-width: 100%;
  margin: 0px;
}
.base_CT16 {
  color: $h_sub_blue2;
}
.join_phone > div:last-child {
  margin-top: 0;
  margin-left: 0px;
}
img {
  width: 100%;
}
.cart_st .box_btn .an_t {
  font-size: 16px;
  line-height: 47px;
  &.alert {
    font-size: 18px;
    line-height: 56px;
  }
}
.info {
  color: #c6c6c6;
}
.agree_ment {
  // border-bottom: 1px solid transparent;
  &.style {
    outline: 2px solid red;
  }
}
[data-detail*='cart_detail'] .btn_wrap[data-detail*='btn_bottom'] {
  margin-top: 15px;
  display: flex;
  justify-content: center;
  gap: 10px;
}
.pay_btn {
  flex: 0.3;
  height: 56px;
  background-color: #006fb9;
  border-radius: 7px;
  letter-spacing: 0.6px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
}
@media (max-width: 768px) {
  .country_list {
    width: 68% !important;
    margin-right: 100%;
  }
  .form_wrap {
    .user-id-wrap {
      // min-width: 152px;
      // flex-direction: column;
    }
    .return_name,
    .return_name > .name_field,
    .join_phone {
      align-items: center;
      flex-wrap: wrap;
      .select_option .txt {
        font-size: 12px;
      }
      .sub_title {
        width: 100%;
        margin: 8px 0px;
      }
    }
  }
}
@media (max-width: 480px) {
  .check_wrap {
    padding: 0 25px;
  }
  .pay_btn {
    flex: 0.5;
    height: 40px;
    font-size: 14px;
  }
  [data-detail*='cart_detail'] .order_book[data-detail*='cart_2'] .info_wrap {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  [data-detail*='cart_detail']
    .order_book[data-detail*='cart_2']
    .info_wrap
    .upside {
    height: auto;
    padding-top: 5px;
    margin-bottom: 0;
  }
  [data-detail*='cart_detail']
    .order_book[data-detail*='cart_2']
    .info_wrap
    .upside
    .order_info {
    padding-left: 0;
    width: 100%;
    line-height: normal;
  }
  [data-detail*='cart_detail']
    .order_book[data-detail*='cart_2']
    .info_wrap
    .downside {
    padding: 12px 20px;
    height: 73px;
  }
  [data-detail*='cart_detail']
    .order_book[data-detail*='cart_2']
    .info_wrap
    .upside
    .order_info:nth-child(2) {
    height: auto;
    padding-left: 11px;
  }
  [data-detail*='cart_detail']
    .order_book[data-detail*='cart_2']
    .info_wrap
    .upside
    .title_gray {
    height: 20px;
  }
}
</style>
